<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">İl</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                <input type="text" class="form-control" placeholder="İl" v-model="value.Name">
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">X Koordinatı</label>
            <v-validator :errors="errors" parameter="X_Coordinate" :watch="value.X_Coordinate">
                <input type="text" class="form-control" placeholder="X Koordinatı" v-model="value.X_Coordinate">
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Y Koordinatı</label>
            <v-validator :errors="errors" parameter="Y_Coordinate" :watch="value.Y_Coordinate">
                <input type="text" class="form-control" placeholder="Y Koordinatı" v-model="value.Y_Coordinate">
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Posta Kodu</label>
            <v-validator :errors="errors" parameter="PostCode" :watch="value.PostCode">
                <input type="text" class="form-control" placeholder="Posta Kodu" v-model="value.PostCode">
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Ülke</label>
            <v-validator :errors="errors" parameter="CountryId" :watch="country">
                <v-select-list v-model="country" v-on:input="getProvinces(true)" placeholder="Ülke" label="Name" :options="countries"/>
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Province</label>
            <v-validator :errors="errors" parameter="ProvinceId" :watch="province">
                <v-select-list :disabled="!value.CountryId" v-model="province" :options="provinces" label="Name" placeholder="İl"></v-select-list>
            </v-validator>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'

export default{
    props:{
        value:Object,
        errors:Object
    },
    mounted(){
        this.getCountries()
        this.getProvinces()
    },
    data(){
        return {
            countries:[],
            provinces: []
        }
    },
    methods:{        
        getCountries(){
            if((this.countries || []).length == 0){
                SystemDataApi.Country().then(res=>{
                    this.countries = res.data.Data
                    if(this.value.CountryId == null){
                        this.value.CountryId = this.countries?.find(c=>c.IsDefault)?.Id  || null
                    }
                    this.getProvinces()
                })
            }else {
                if(this.value.CountryId == null){
                    this.value.CountryId = this.countries?.find(c=>c.IsDefault)?.Id  || null
                }
                this.getProvinces()
            }
        },
        getProvinces(bool){
            if(bool) this.value.ProvinceId = null
            if(this.value.CountryId){
                SystemDataApi.ProvinceByCountry(this.value.CountryId).then(response=>{
                    this.provinces = response.data.Data
                })
            }
        }
    },
    computed:{
        country:{
            get:function(){
                return this.countries.find(b=>b.Id==this.value.CountryId)
            },
            set:function(value){
                this.value.CountryId = value?.Id || null
            }
        },
        province:{
            get:function(){
                return this.provinces.find(b=>b.Id==this.value.ProvinceId)
            },
            set:function(value){
                this.value.ProvinceId = value?.Id || null
            }
        }
    },
}
</script>